<template>
  <div class="tools-partners-profiles">
    <div class="row justify-content-between">
      <div class="d-flex align-items-center col-lg-6 order-1 order-lg-0">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
      <div class="col-lg-6 d-flex align-items-center">
        <search-filter
          :show-results-dropdown="false"
          placeholder="Pesquisar"
          class="flex-fill"
          @search="onSearch"
          new-design
        />

        <div class="d-none d-lg-flex ml-3">
          <button
            class="btn btn-primary btn-primary px-5 btn-sm btn-40"
            @click="add"
          >
            <i class="fa-solid fa-plus mr-6" />
            Adicionar perfil
          </button>
        </div>
      </div>

      <div class="col-12 d-lg-none my-6">
        <button
          class="btn btn-primary btn-primary btn-block btn-sm btn-40"
          @click="add"
        >
          <i class="fa-solid fa-plus mr-6" />
          Adicionar perfil
        </button>
      </div>
    </div>

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>
    <div
      v-else-if="!_profiles.length"
      class="container centralize-row text-center pt-5"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.svg"
          />
          <h5>Você ainda não cadastrou perfis</h5>
          <div class="text-secondary mb-5">
            Clique no botão acima para cadastrar
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- desktop area -->
      <data-table
        new-design
        class="d-none d-lg-block"
        columnsFr="0.5fr 1fr 0.1fr"
        :data="_profiles"
        :columns="columns"
      >
        <template #default="{ item }">
          <small>
            {{ item.name }}
          </small>

          <small>
            {{ formatPermission(item.scope[0]) }}

            <b-dropdown
              v-if="item.scope.length > 1"
              no-caret
              size="sm"
              class="ml-3"
              variant="outline-primary"
              toggle-class="events-button"
            >
              <template #button-content>
                +{{ item.scope.length - 1 }}
                <i class="fa fa-angle-down ml-2" />
              </template>
              <b-dropdown-text>
                <div
                  v-for="(permission, index) in item.scope"
                  class="pt-3 px-5 text-secondary small"
                  :key="index"
                >
                  {{ formatPermission(permission) }}
                </div>
              </b-dropdown-text>
            </b-dropdown>
          </small>

          <div class="d-flex justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions"
              @edit="edit(item)"
              @remove="remove(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of desktop -->
      <!-- mobile area -->
      <data-table
        new-design
        class="d-lg-none"
        :data="_profiles"
        :columns="['', '']"
      >
        <template #default="{ item }">
          <div class="d-flex flex-column py-5 responsive-table">
            <span>
              <strong>Perfil: </strong>
              {{ item.name }}
            </span>

            <span>
              <strong>Permissões: </strong>
              <b-dropdown
                no-caret
                size="sm"
                class="ml-3"
                variant="outline-primary"
                toggle-class="events-button"
              >
                <template #button-content>
                  {{ item.scope.length }}
                  <i class="fa fa-angle-down ml-2" />
                </template>
                <b-dropdown-text>
                  <div
                    v-for="(permission, index) in item.scope"
                    class="pt-3 px-5 text-secondary small"
                    :key="index"
                  >
                    {{ formatPermission(permission) }}
                  </div>
                </b-dropdown-text>
              </b-dropdown>
            </span>
          </div>

          <div class="d-flex align-items-center justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions"
              @edit="edit(item)"
              @remove="remove(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of mobile -->
    </div>

    <div class="mt-5 d-flex justify-content-end">
      <paginator
        v-show="_profiles.length && !loading"
        :pagination="pagination"
        @on-update="dispatch"
      />
    </div>

    <action-dispatcher
      action="partnersCenter/getPermissions"
      @on-pagination-update="dispatch"
      loading-class="d-none"
    >
      <responsive-modal v-model="dialog" size="lg">
        <profile-modal
          v-if="dialog"
          :item="toEdit"
          @reload="dispatch"
          @close="dialog = false"
        />
      </responsive-modal>
    </action-dispatcher>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";
import ProfileModal from "./ProfileModal";

export default {
  components: { ProfileModal },
  data() {
    return {
      search: "",
      toEdit: null,
      dialog: false,
      loading: false,
      actions: [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "fa-solid fa-trash",
          confirmation: {
            enable: true,
            newDesign: true,
            submitButtonClass: "btn-danger",
            text: "Tem certeza que deseja remover este perfil?"
          },
          event: "remove"
        }
      ],
      columns: ["Perfil", "Permissões", ""],
      pagination: {
        count: 0,
        next: "",
        previous: ""
      }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["profiles", "permissions"]),
    _profiles() {
      return this.profiles.map(profile => ({
        ...profile,
        scope: Object.keys(profile.scope)
      }));
    },
    _permissions() {
      return this.permissions.reduce(
        (prev, cur) => [...prev, ...cur.permissions],
        []
      );
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    formatPermission(permission) {
      return permission
        ? get(
            this._permissions.find(p => p.code === permission),
            "name",
            "Erro"
          )
        : "Erro";
    },
    edit(item) {
      this.toEdit = item;
      this.dialog = true;
    },
    add() {
      this.edit(null);
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getProfiles", { search: this.search, offset })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch(search) {
      this.search = search;
      this.dispatch();
    },
    remove(item) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/deleteProfile", item.id)
        .then(this.dispatch)
        .catch(() => {
          this.$message.error("Erro ao remover perfil");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-partners-profiles {
  .event-button {
    padding: 2px 8px;
  }
}
</style>
